import * as React from "react";
import { Table, TableBody, TableCell, TableContainer, TableRow, Typography, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./BasketOverviewPopover.styles";
import { NavLink, useHistory } from "react-router-dom";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import { useTranslation } from "react-i18next";
import Popover from "material-ui-popup-state/HoverPopover";
import { bindHover, bindPopover, usePopupState } from "material-ui-popup-state/hooks";
import { BlueButton } from "../Buttons/BlueButton";
import { ccyFormat } from "../../../utilities/PriceUtils";
import { findCategoryByName, findProductByName } from "../../views/productOverview/ProductHelper";
import { useSelector } from "react-redux";

export interface IBasketItem {
    price: number;
    product: string;
}

export interface IBasketOverviewPopoverProps extends WithStyles<typeof styles> {
    items: IBasketItem[];
}

const BasketOverviewPopoverPure: React.FunctionComponent<IBasketOverviewPopoverProps> = ({
                                                                                             classes,
                                                                                             items
                                                                                         }: IBasketOverviewPopoverProps) => {
    const {t} = useTranslation();
    const history = useHistory();
    const popupState = usePopupState({
        variant: "popover",
        popupId: "basketPopover"
    });

    const handleProceedToCheckout = () => {
        history.push("/basket/1");
    };

    const productsInfo = useSelector((state) => state.products);

    const totalPrice = items?.map(item => item.price)?.reduce((a, b) => a + b, 0);

    return (
        <div>
            <div {...bindHover(popupState)}>
                <NavLink to="/basket/1" className={classes.link} key="basket">
                    <ShoppingCartOutlinedIcon />
                    {t("general.basket")} ({items?.length})
                </NavLink>
            </div>
            {items?.length > 0 && (
                <Popover
                    {...bindPopover(popupState)}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    disableRestoreFocus
                >
                    <div className={classes.root}>
                        <TableContainer className={classes.container}>
                            <Table size="small" className={classes.table}>
                                <TableBody>
                                    {items.map((item, i) => {
                                        const product = findProductByName(productsInfo?.products, item["product"]);

                                        return (
                                            <TableRow key={i}>
                                                <TableCell className={classes.tableCell} width="180px" align="left">
                                                    <div
                                                        className={classes.productCategory}>{findCategoryByName(productsInfo?.categories, product?.category)?.name}</div>
                                                    <div>
                                                        <Typography variant="body2" display="block">
                                                            {product?.name}
                                                        </Typography>
                                                    </div>
                                                </TableCell>
                                                <TableCell className={classes.tableCell} width="40px" align="right">
                                                    {ccyFormat(item.price)}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Table size="small" className={classes.table}>
                            <TableBody>
                                <TableRow key="total">
                                    <TableCell className={classes.tableCellTotal} align="left">
                                        <b>TOTAL</b>
                                    </TableCell>
                                    <TableCell className={classes.tableCellTotal} align="right">
                                        <b>{ccyFormat(totalPrice)}</b>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        <div className={classes.button}>
                            <BlueButton onClick={handleProceedToCheckout} fullWidth>
                                {t("mainNavBar.proceedToCheckout")}
                            </BlueButton>
                        </div>
                    </div>
                </Popover>
            )}
        </div>
    );
};

export const BasketOverviewPopover = withStyles(styles)(BasketOverviewPopoverPure);
